module.exports = __webpack_public_path__ + "static/img/logo-asana.adf903ff.svg";